"use client";

import { useTranslations } from "next-intl";

import { useModalStore } from "@/store/modal.store";
import Button from "@/ui/Common/Button";
import { Divider } from "@/ui/Divider";
import { cn } from "@/utils/cn";
import { ModalHeader } from "@/widgets/Modal/Header";

import styles from "./style.module.scss";

export const MessengerNotInstalled = () => {
  const t = useTranslations();
  const { closeModal } = useModalStore();

  const handleClose = () => {
    closeModal();
  };

  return (
    <div className={cn(styles.wrapper, "relative")}>
      <ModalHeader
        title={t(
          "It seems you don't have the app installed. Please install it to use this feature.",
        )}
      />
      <Divider />
      <div className={cn(styles.buttonContainer, "py-12 px-16")}>
        <Button
          type="white"
          onClick={handleClose}
          className="h-[5.4rem]"
        >
          {t("Return")}
        </Button>
      </div>
    </div>
  );
};

export default MessengerNotInstalled;
